import serverCall from "../../serverCall";

const getAllUser = (payload) => {
  try {
    const response = serverCall.post(`/admin/getall-user`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

const getUserDetails = (userId) => {
  try {
    const response = serverCall.get(`/admin/user/${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const createUser = (body) => {
  try {
    const response = serverCall.post(`/admin/create/user`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateUser = (userId, body) => {
  try {
    const response = serverCall.put(`/admin/user/update/${userId}`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteUser = (userId) => {
  try {
    const response = serverCall.delete(`/admin/user/delete/${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

/* const updateAdminProfile = (body, userId) => {
  try {
    const response = serverCall.patch(`/admin/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
}; */

/* const adminFileUpload = (body) => {
  try {
    const response = serverCall.post(`/company/update-company`, body);
    return response;
  } catch (error) {
    throw error;
  }
}; */

/* const getCompany = () => {
  try {
    const response = serverCall.get(`/company/get-companies`);
    return response;
  } catch (error) {
    throw error;
  }
}; */

const getProfile = () => {
  try {
    const response = serverCall.get(`/users/profile`);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateProfile = (formData) => {
  try {
    const response = serverCall.patch(`/users/profile`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateLanguage = (language) => {
  try {
    const response = serverCall.patch(`/users/language`, { language });
    return response;
  } catch (error) {
    throw error;
  }
};

const UserService = {
  getAllUser,
  getUserDetails,
  createUser,
  updateUser,
  deleteUser,
  getProfile,
  updateProfile,
  updateLanguage,
};

export default UserService;
